module.exports = __webpack_public_path__ + "assets/icon-cancel.9971bdb7.svg";